import React, { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { getWopiOfficeURL } from "../../services/wopi.service.js";
import { OfficeViewerContainer } from "./OfficeDocsViewer.Styles.js";
import axios from "axios";

const OfficeViewer = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") || "view";

  const [accessToken, setAccessToken] = useState(null);
  const [error, setError] = useState(null);
  const userId = parseInt(localStorage.getItem("id"));

  const coreAccessToken = sessionStorage.getItem("accessToken");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const headers = { Authorization: `${coreAccessToken}` };

  // Get WOPI office URL
  const wopiOfficeURL = useMemo(
    () => `${getWopiOfficeURL(id, mode)}`,
    [id, mode]
  );

  // Calculate the access token TTL (expiration time)
  const accessTokenTTL = useMemo(() => {
    const expirationTime = Math.floor(Date.now() / 1000) + 3600;
    return expirationTime * 1000;
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const res = await axios.get(`${baseUrl}/customer/getToken`, {
          headers,
        });
        setAccessToken(res.data);
      } catch (err) {
        console.error("Failed to fetch token:", err);
        setError("Could not fetch access token. Please try again.");
      }
    };

    fetchToken();
  }, [baseUrl]);

  useEffect(() => {
    if (!accessToken) return;

    const frameholder = document.getElementById("frameholder");
    if (!frameholder) {
      console.error("Frameholder element not found");
      return;
    }

    const officeFrame = document.createElement("iframe");
    officeFrame.name = "office_frame";
    officeFrame.id = "office_frame";
    officeFrame.height = "100%";
    officeFrame.width = "100%";
    officeFrame.title = "Office Viewer";

    officeFrame.setAttribute("allowfullscreen", "true");
    officeFrame.setAttribute(
      "sandbox",
      "allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
    );
    frameholder.appendChild(officeFrame);

    document.getElementById("office_form").submit();

    return () => {
      // cleanup iframe when component unmounts
      if (frameholder.contains(officeFrame)) {
        frameholder.removeChild(officeFrame);
      }
    };
  }, [wopiOfficeURL, accessToken]);

  if (error) {
    return (
      <OfficeViewerContainer>
        <div className="error-message">{error}</div>
      </OfficeViewerContainer>
    );
  }

  if (!accessToken) {
    return (
      <OfficeViewerContainer>
        <div>Loading Office Viewer...</div>
      </OfficeViewerContainer>
    );
  }

  return (
    <OfficeViewerContainer>
      <form
        id="office_form"
        name="office_form"
        target="office_frame"
        action={wopiOfficeURL}
        method="post"
        className="d-none"
      >
        <input name="access_token" value={accessToken} type="hidden" />
        <input name="access_token_ttl" value={accessTokenTTL} type="hidden" />
        <input name="user_id" value={userId} type="hidden" />
        <input name="owner_id" value={userId} type="hidden" />
      </form>

      <div id="frameholder" className="w-100 h-100"></div>
    </OfficeViewerContainer>
  );
};

export default OfficeViewer;
